/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Vue, Component, Prop } from 'vue-property-decorator';

import { Field } from 'vant';
import { Toast } from '@hb/coffee';

import { trimAll } from '@/shared/utils/trim';
import { LoginResponseType } from '@/api/login/types';
import CommonApi from '@/api/common';
import { ubtSendError } from '@/shared/utils/ubt';
import { SYSTEM_CODE } from '@/constant/system';
import { env } from '@/constant';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import MessagePop from './component/message-pop';
import { CallBackActionEnum, EvokeAppTypeEnums, PageVersionTypeEnums } from '../../types';

import style from './index.module.scss';
import BottomTips from '../bottomTips';
import RiskTips from './component/risk-tips/RiskTisp';

import { pageFeatureConfig, riskTipsWisdomKeyEnum } from '../../config';
import type { pageConfigType } from '../../config';

import customStyleConfig from './const';

/** 异步加载一键登录sdk */
const h5LoginLoader = async () => {
  const { default: h5Login } = await import(/* webpackChunkName: "h5-login" */'@hb/h5-login');

  return h5Login;
};


/** h5外投改版 */
@Component({
  name: 'OutRelease',
})
export default class OutRelease extends Vue {
  /** 合同协议 */
  @Prop(String) readonly contracts!: string[];

  /** 页面版本 */
  @Prop(String) readonly pageVersion!: PageVersionTypeEnums;

  /** 验证码弹窗是否展示 */
  private messagePop = false;

  /** 当前用户手机号 */
  private phone = '';

  /** 用户是否同意协议 */
  private check = false;

  /** 风险提示文案 */
  private riskTips = '';

  /** 将关闭弹窗的方法暴露给父组件调用 */
  public closeMessagePop():void {
    this.messagePop = false;
  }

  private async mounted() {
    /** 获取配置平台配置数据 */
    const riskTipsConfig = await Vue.prototype.$tangram.getConfigValue({
      moduleCode: 'financial',
      keyCode: this.currentConfig?.riskTipsConfigKey || riskTipsWisdomKeyEnum.VERSION_ONE,
    });
    const pageConfig = riskTipsConfig[this.pageVersion] || {};
    this.riskTips = pageConfig.riskTips || '';

    /** 预渲染无需后续初始化 */
    if (IS_PRERENDERING) return;

    /** 一键登录模式-初始化 */
    if (this.currentConfig?.isAutoLogin) {
      this.initAutoLogin();
    }
  }

  private get PhoneImg():string {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return require('./images/phone.png');
  }

  private get currentConfig(): pageConfigType | undefined {
    return pageFeatureConfig.get(this.pageVersion);
  }

  /** 根据pageType获取当前按钮名称 */
  private get buttonName(): string | undefined {
    return (this.currentConfig && this.currentConfig.buttonName) || '查看我的额度';
  }

  /** 根据pageType获取利率描述文本 */
  private get rateDes(): string | undefined {
    return this.currentConfig && this.currentConfig.rateDes;
  }

  /** 根据pageType获取是否隐藏「一千元最低0.3元/天」文案 */
  private get hidenPrerateDes(): boolean | undefined {
    return this.currentConfig && this.currentConfig.hidenPrerateDes !== false;
  }

  private get showProductDescription(): boolean | undefined {
    return this.currentConfig && !this.currentConfig.notShowProductDescription;
  }

  /** 根据pageType获取当前按钮样式类，区分角标 */
  private get buttonClassName(): string {
    return (this.currentConfig && this.currentConfig.icon) || '';
  }

  /** 根据配置获取placeholder文案 */
  private get placeholder(): string {
    return (this.currentConfig && this.currentConfig.placeholder) || '请输入手机号码';
  }

  /** 根据配置获取输入框左侧icon图标 */
  private get inputLeftIcon(): string {
    if (this.currentConfig && this.currentConfig.inputLeftIcon !== undefined) {
      return this.currentConfig && this.currentConfig.inputLeftIcon;
    }
    return this.PhoneImg;
  }

  /** 根据配置获取利率数字风格 */
  private get interestValueTheme(): string {
    return (this.currentConfig && this.currentConfig.interestValueTheme) || '';
  }

  /** 根据配置获取是否展示权益模块 */
  private get showRight(): boolean {
    return (this.currentConfig && this.currentConfig.showRight) || false;
  }

  /** 是否哈臻快-落地页 */
  private get isRechargeAppMarket(): boolean {
    return this.currentConfig
      ? this.currentConfig.evokeAppType === EvokeAppTypeEnums.RECHARGE : false;
  }

  private formatToastTips(message: string) {
    return {
      message,
      duration: 1500,
    };
  }

  /** 发送验证码 */
  private async sendCode() {
    await CommonApi.getLoginCode(this.phone);
    this.$nextTick(() => {
      Toast(this.formatToastTips('验证码已发送'));
    });
  }

  /** 点击进入登录流程 */
  private async onClickLoginBtn() {
    /** 一键登录模式，无需进入手机输入流程，直接调用sdk进入一键登录 */
    if (this.currentConfig?.isAutoLogin) {
      this.$ubtModuleExposeNew('finance_loan_autoLoginDialog_applyClick');
      this.startAutoLogin();
      return;
    }

    await this.doCheckPhone();
    await this.doCheckAgreement();
    this.messagePop = true;
    // 触发验证码获取埋点
    this.$ubtPageButton(
      'finance_smsMarketing_landingPage_otp',
      'pageVersion',
      this.pageVersion,
    );
    this.sendCode();
  }

  private async startAutoLogin() {
    try {
      const h5Login = await h5LoginLoader();
      const userInfo = await h5Login.signIn({
        operatorDialogClass: 'market__auto-login-dialog',
        operatorLogin: true,
        beforeProtocolClick: (url) => {
          this.$emit('contractClick');
          return '';
        },
        operatorStyleConfig: customStyleConfig,
        onCMLoginShow: () => this.$ubtModuleExposeNew('finance_loan_autoLoginDialog_expose'),
        onCMLoginSwitchClick: () => this.$ubtModuleExposeNew('finance_loan_autoLoginDialog_otherClick'),
        onCMLoginGetTokenSuccess: () => this.$ubtModuleExposeNew('finance_loan_autoLoginDialog_auloLoginClick'),
      });
      // 正常情况下未登录成功不会抛出异常，通过userInfo是否不为空判断登录成功
      if (!userInfo || !userInfo.token) {
        throw new Error(`userInfo error: ${JSON.stringify(userInfo)}`);
      }
      // eslint-disable-next-line no-console
      console.log('登录成功', userInfo);
      this.$ubtModuleExposeNew('finance_loan_autoLoginDialog_loginSuccess');
      /** 登录成功，回调刷新登录态，以及更新下载app */
      this.$emit('confirm', userInfo, this.currentConfig?.buttonCalllBackType);
    } catch (err) {
      ubtSendError(`登录失败:${(err as Error)?.message}`);
    }
  }

  private async initAutoLogin() {
    const h5Login = await h5LoginLoader();
    h5Login.initConfig({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      env: env as any,
      systemCode: SYSTEM_CODE,
      /** 是否开启日志开关 */
      debug: false,
    });
  }

  /** 同意协议 */
  private onAgree() {
    this.check = !this.check;
  }

  /** 校验手机号 */
  private doCheckPhone() {
    const phone = trimAll(this.phone);
    const regResult = (/^1\d{10}$/).test(phone);
    return new Promise((resolve, reject) => {
      if ((regResult)) {
        resolve(true);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        Toast(this.formatToastTips('请输入正确的手机号'));
        reject();
      }
    });
  }

  private doCheckAgreement() {
    return new Promise((resolve, reject) => {
      if ((this.check)) {
        resolve(true);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        Toast(this.formatToastTips('请先同意相关协议'));
        reject();
      }
    });
  }

  /** 申请额度按钮 */
  private emitConfirm(platformUserInfo:LoginResponseType) {
    const callBackAction = this.currentConfig
      ? this.currentConfig.buttonCalllBackType : CallBackActionEnum.GO_TO_INFO_PAGES;
    this.$emit('confirm', platformUserInfo, callBackAction);
  }

  /** 同意协议 */
  private onContractClick(index:number) {
    this.$emit('contractClick', index);
  }

  /** 审核需要，针对014，013加的特殊样式 */
  private get emphasis() {
    return [
      PageVersionTypeEnums.BRAND_VERSION_BAIDU,
      PageVersionTypeEnums.BRAND_VERSION_RISK,
      PageVersionTypeEnums.RIGHT_VERSION,
    ].includes(this.pageVersion);
  }

  private render() {
    return (
      <div class={[style['out-release-wrapper'], style[`out-release-${this.pageVersion}`]]}
           ref="outRelease">
          <div class={[style['main-wrapper'], style['main-auto-login']]}>
            <div class={[style['main-title'], style['main-color']]}><span>急速借款 · 最高可借</span></div>
            <div class={style['possible-num']}>200,000</div>
            {this.showProductDescription && <div class={[style['product-description'],
              this.emphasis && style['description-emphasis'],
              style[this.interestValueTheme]]}>
              {!this.hidenPrerateDes && <span>1千元最低0.3元/天 </span>}
              <span class={style['description-gery']}>
                {this.rateDes ? this.rateDes
                  : <span>综合年化利率(单利)降至<span class={style['color-num']}>4.9%</span>起</span>}
              </span>
            </div>}
            {this.showRight && <div class={style['right-coupon']}/>}
            {!this.currentConfig?.isAutoLogin && (
              <div class={style['input-wrapper']}>
                <Field class={style['phone-input']}
                  v-model={this.phone}
                  placeholder={this.placeholder}
                  leftIcon={this.inputLeftIcon}
                  type="tel"
                  maxlength="11"
                >
                </Field>
              </div>
            )}
            <div class={[style['button-review'], style[`button-${this.buttonClassName}`]]}
                 onClick={this.onClickLoginBtn.bind(this)}>
                 {this.buttonName}
            </div>
            {!this.currentConfig?.isAutoLogin && (
              <div class={style['agreement-wrapper']}>
                <span class={[style['agreement-check'], this.check && style.checked]}
                  onClick={this.onAgree.bind(this)}>
                </span>
                <div class={style['agreement-name-wrapper']}>
                  <span class={style['agreement-read-text']}>我已阅读并同意</span>
                  {this.contracts.map((item, index) => (
                  <span class={style['agreement-name']}
                        onClick={this.onContractClick.bind(this, index)}>
                    {item}
                  </span>))}
                </div>
              </div>
            )}
          </div>
          <BottomTips showRisk={!this.riskTips} pageVersion={this.pageVersion} />
          <MessagePop
            v-model={this.messagePop}
            pageVersion={this.pageVersion}
            phone={this.phone}
            buttonName={this.buttonName}
            onConfirm={this.emitConfirm.bind(this)}
            onClose={() => { this.messagePop = false; }}
            onReSendCode={this.sendCode.bind(this)}>
          </MessagePop>
          {/* 风险文档配置至winsdom平台中：https://config.hellobike.cn/#/mobile/detail?env=pro&teamName=%E5%93%88%E5%95%B0%E5%87%BA%E8%A1%8C-%E9%87%91%E8%9E%8D-H5 */}
          {this.riskTips
          && <RiskTips text={this.riskTips} isRechargeAppMarket={this.isRechargeAppMarket}/>
          }
      </div>
    );
  }
}
